// neo_cogym — 인증 세션 클라이언트 (W8)
import { apiFetch, setToken, getToken } from "./client";

export interface SessionUser {
  userId: string;
  tenantId: string;
  role: "owner" | "admin" | "teacher" | "student" | "guardian";
}

export async function login(email: string): Promise<SessionUser> {
  const { token, user } = await apiFetch<{ token: string; user: SessionUser }>("/api/auth/login", {
    method: "POST",
    body: JSON.stringify({ email }),
  });
  setToken(token);
  return user;
}

export async function me(): Promise<SessionUser | null> {
  if (!getToken()) return null;
  try {
    const { user } = await apiFetch<{ user: SessionUser }>("/api/auth/me");
    return user;
  } catch {
    setToken(null);
    return null;
  }
}

export async function logout(): Promise<void> {
  try {
    await apiFetch("/api/auth/logout", { method: "POST" });
  } finally {
    setToken(null);
  }
}
